import { IconProps } from "../../utils/global-types/global-types";

const ResendShareIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_11695_119144)">
      <path
        fill="currentColor"
        d="M15.781 8.402a.22.22 0 0 1-.073.164l-5.519 4.895a.219.219 0 0 1-.364-.164V10.77a7.37 7.37 0 0 0-7.001 4.801.22.22 0 0 1-.205.143l-.016-.001a.22.22 0 0 1-.198-.171 7.78 7.78 0 0 1 1.54-6.572 7.8 7.8 0 0 1 5.88-2.934V3.507a.22.22 0 0 1 .364-.164l5.519 4.896a.22.22 0 0 1 .073.163"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_11695_119144">
        <path fill="currentColor" d="M2 2.501h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ResendShareIcon;
